import React, { useState } from 'react'
import cateringCss from './catering-css'
import NavBar from '../../components/nav-bar/nav-bar'
import Footer from '../../components/footer/footer'
import PageTitle from '../../components/page-title/page-title'
import Section from '../../components/section/section'

const CateringView: React.FC = () => {
  const [isRotated, setIsRotated] = useState<boolean>(false)

  return (
    <>
      <NavBar />
      <PageTitle marginTop>Na jaké dobroty se můžete těšit?</PageTitle>

      {/* starter */}
      <Section isBackgroundBlue>
        <div className={cateringCss.section()}>
          <p className={cateringCss.sectionTitle()}>Lehké občerstvení před obřadem</p>
          <p className={cateringCss.sectionSubtitle()}>Občerstvení najdete v restauraci před vigvamem.</p>

          <ul>
            <li> - Cherry rajčátko plněné sýrem ricotta s pažitkou</li>
            <li> - Parmská šunka s melounem a rucolou</li>
            <li> - Párečky od pana Černého</li>
            <li> - Variace pomazánek na domácím chlebu</li>
            <li> - Ovocné špízky</li>
          </ul>
        </div>
      </Section>

      {/* lunch */}
      <Section>
        <div className={cateringCss.section()}>
          <p className={cateringCss.sectionTitle()}>Svatební menu</p>
          <p className={cateringCss.sectionSubtitle()}>Oběd se bude podávat uvnitř vigvamu.</p>

          <p className={cateringCss.lunchSubtitle()}>Polévka</p>
          <p> - Hovězí vývar s játrovými knedlíčky a zeleninou</p>

          <p className={cateringCss.lunchSubtitle()}>Hlavní chod</p>
          <p> - Hovězí pečeně na smetaně s karlovarským knedlíkem a brusinkami</p>

          <p className={cateringCss.lunchSubtitle()}>Hlavní chod pro ty kteří uvedly, že mají alergii na mléko</p>
          <p> - Grilované kuřecí prso Supreme s baby brambůrkami, pečenou paprikou a domácím demi-glace</p>

          <p className={cateringCss.lunchSubtitle()}>Dezert</p>
          <p> - Svatební dort</p>
          <p className={cateringCss.paragraphSubtitle()}>(vanilkový korpus, pistáciový krém a malinový gel)</p>
        </div>
      </Section>

      {/* seating plan */}
      <Section isBackgroundBlue>
        <div className={cateringCss.section()}>
          <p className={cateringCss.sectionTitle()}>Zasedací pořádek na oběd uvnitř vigvamu</p>
          <p className={cateringCss.sectionSubtitle()}>Pro hladší průběh doporučujeme si prohlédnout zasedací pořádek, abyste věděli, kde budete sedět.</p>

          <div className={cateringCss.wrapperSeatingPlanFoto(isRotated)}>
            <img src="assets/seating-map.png" alt="foto-1" className={cateringCss.seatingPlanFoto(isRotated)} />
          </div>
          <p>
            <button className={cateringCss.button()} onClick={() => setIsRotated((prev) => !prev)}>Otočit obrázek</button>
          </p>
        </div>
      </Section >

      {/* buffet */}
      < Section >
        <div className={cateringCss.section()}>
          <p className={cateringCss.sectionTitle()}>Večerní raut včetně grilování</p>
          <p className={cateringCss.sectionSubtitle()}>Raut bude k dispozici v podvečer. Šéfkuchaři budou grilovat venku za vigvamem a studený raut se bude podávat uvnitř vigvamu.</p>

          <ul>
            <li> - Vepřové a kuřecí  mini řízečky</li>
            <li> - Lehce zauzená kachní prsa s chutney</li>
            <li> - Filírované krůtí prso s omáčkou z pečených paprik</li>
            <li> - Hovězí tataráček s topinkami</li>
            <li> - Uzenářské prkénko zdobené beraními rohy</li>
            <li> - Sýrové prkénko zdobené ovocem</li>
            <li> - Caprese salát, salát Coleslaw</li>
            <li> - Čerstvá zelenina</li>

            <li> - Grilovaná filírovaná masa: hovězí, zvěřina, vepřové, kuřecí</li>
            <li> - Grilovaný steak z lososa marinovaný v citrusech</li>
            <li> - Marinovaná vepřová žebra</li>
            <li> - Domácí mini hamburgery</li>
            <li> - Grilovaný hermelín</li>
            <li> - Grilovaná zelenina</li>
            <li> - Rozmarýnové grenaille</li>
            <li> - Dresinky, salsa, bruschetta, pečivový set</li>
          </ul>
        </div>
      </Section >

      {/* sweet bar */}
      < Section isBackgroundBlue >
        <div className={cateringCss.section()}>
          <p className={cateringCss.sectionTitle()}>Sweet bar</p>
          <p className={cateringCss.sectionSubtitle()}>Něco sladkého najdete uvnitř vigvamu.</p>

          <ul>
            <li> - Sněhové pusinky</li>
            <li> - Cakepops (čokoláda s oříškem v hořké čokoládě, pistácie v bílé čokoládě)</li>
            <li> - Pohárek (harlekýn, red velvet, panna cotta s ovocným rozvarem)</li>
            <li> - Mini cupcakes (čokoládový korpus, smetanový krém)</li>
            <li> - Francouzský věneček s lískooříškovým krémem</li>
            <li> - Makronky (pistácie - světle zelená, kokos - bílá, citron - světle modrá, čokoláda - modrá)</li>
            <li> - Tartaletka (čokoláda s lískovým oříškem, slaný karamel, maracuja s mangem a kokosovým krémem, pistácie s malinovým gelem)</li>
          </ul>
        </div>
      </Section >
      <Footer />
    </>
  )
}

export default CateringView
